module.exports = __webpack_public_path__ + "static/img/1-1.8fca281.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/10/eng/1-1.png
// module id = F0Hs
// module chunks = 0